<script setup>
    import { router } from '@inertiajs/vue3';
    import PreviewLayout from '@/Layouts/PreviewLayout.vue';
    import ShowAndFilterActions from '@/Pages/Toolkit/ShowAndFilterActions.vue';
    import DashboardSidebar from '@/Jetstream/DashboardSidebar.vue';
    import ActionsSearch from '@/Pages/Toolkit/Partials/ActionsSearch.vue';
    import Locale from '@/Pages/Shared/Locale.vue';

    const props = defineProps({
        toolkit: Object,
        actions: Array,
        areas: Array,
        statuses: Array,
        themes: Array,
        sdgs: Array,
        awards: Array,
        loggedInUserId: Number,
        currentToolkitTeamUsers: Array,
        available_locales: Array,
        teamToolkit: Object,

        filters: {
            type: Object,
            default: () => ({}),
        },
    });

    const emit = defineEmits(['statusChanged']);

    const statusChanged = (action, status) => {
        emit('statusChanged', action, status);
    };

    const programme = router.page.props.programme;
    const organisation = router.page.props.organisation;

    const organisation_name = (programme.organisation_custom_name && programme.organisation_custom_name.length == 0) ? programme.organisation_custom_name : 'Organisation' ;
    const team_name = (programme.organisation_custom_name && programme.team_custom_name.length == 0) ? programme.team_custom_name : 'Team' ;

    let availableLocales = props.available_locales;

</script>


<template>
    <PreviewLayout title="Toolkit">
        <div class="preview-banner">
            <div class="mx-auto max-w-7xl py-3 px-3 sm:px-6 lg:px-8 text-center">
                <p class="ml-12 truncate font-extrabold text-white">
                    <span class="md:hidden">{{ $t('toolkit.preview.preview_mode_short') }}</span>
                    <span class="hidden md:inline">{{ $t('toolkit.preview.preview_mode_long') }}</span>
                </p>
            </div>
        </div>

        <div class="container mx-auto flex flex-col lg:flex-row justify-between w-full">

            <!-- <div id="sos-programme-dashboard-sidebar" class="order-2 lg:order-1 w-full lg:w-1/4 xl:w-1/5 min-h-screen p-10 pt-5">
                <DashboardSidebar />
            </div> -->

            <div class="order-1 lg:order-2 w-full lg:w-3/4 xl:w-4/5 sos-programme-dashboard-content">
                <div class="overflow-hidden pl-10 mb-10 pr-10 lg:pr-0 pt-3">
                    <div id="toolkit-header" class="md:flex">
                        <div class="md:basis-1/2">
                            <h1 class="dashboard-title pt-5">{{ $t('toolkit.toolkit') }}</h1>
                            <p class="font-bold">{{ $t('toolkit.team') }} {{ !$page.props.preview ? $page.props.auth.user.current_team.name : $t('toolkit.preview.team')}}</p>
                        </div>
                        <div class="md:basis-1/2">
                            <div class="float-right">
                                <!-- Language Dropdown -->
                                <div style="display: inline-flex;" class="align-middle mr-2">{{ $t('toolkit.preview.preview_dropdown') }}</div>
                                <div style="display: inline-flex;" class="align-middle"><Locale :currentLocale="$i18n.locale" :availableLocales="availableLocales" /></div>
                            </div>
                        </div>
                        <!-- <ActionsSearch /> -->
                    </div>

                    <div class="toolkit-intro">
                        {{ $t('toolkit.intro_text') }}
                    </div>

                    <div class=" pt-5 lg:pr-0">
                        <ShowAndFilterActions :toolkit="toolkit" :currentToolkitTeamUsers="currentToolkitTeamUsers" :actions="actions" :areas="areas" :statuses="statuses" :themes="themes" :sdgs="sdgs" :awards="awards" :loggedInUserId="loggedInUserId" :filters="filters" @statusChanged="statusChanged" />
                    </div>
                </div>
            </div>
        </div>
    </PreviewLayout>
</template>
